import * as React from "react";

interface ISitesRouterProps {}

export const SitesRouter: React.FC<ISitesRouterProps> = (props) => {
	return <div>Sites</div>;
};
